import request from '@/config/axios'

export interface ReceivableVO {
  id: number
  no: string
  planId?: number
  customerId?: number
  customerName?: string
  contractId?: number
  /**
   * 合同信息
   *
   * ★ 后端 CrmReceivableController#buildReceivableDetailList 会把整个 CrmContractRespVO
   *   塞进来，所以回款列表的「订单编号 / 合同类型 / 签约日期 / 生效日期 / 交付日期 /
   *   收付款 / 付款方式 / 付款分期 / 说明」等列直接读这里的字段即可，
   *   回款侧不需要再冗余一份（原型见 `原型图/客户/财务/全部回款-列表页.png`）。
   */
  contract?: {
    id?: number
    name?: string
    no?: string
    totalPrice?: number
    /** 订单编号（合同上的文本冗余字段） */
    orderNo?: string
    /** 合同类型，字典 crm_contract_type */
    contractType?: string
    /** 签约日期 */
    signDate?: Date | string
    /** 合同开始时间 —— 回款列表的「生效日期」列取它 */
    startTime?: Date | string
    /** 合同结束时间（合同列表 label 为「到期日期」）—— 回款列表的「交付日期」列取它 */
    endTime?: Date | string
    /** 收/付款方向，字典 crm_contract_payment_direction：1 收款单 / 2 付款单 */
    paymentDirection?: number
    /** 付款方式，字典 crm_contract_payment_method */
    paymentMethod?: string
    /** 付款分期，字典 crm_contract_installment */
    installment?: string
    /** 说明（回款列表的「说明」列取它；与回款自身的 remark 是两个字段） */
    description?: string
  }
  /** 首款时间 = 该合同最早一笔回款的回款日期（后端聚合查询，回款列表「首款时间」列用） */
  firstReturnTime?: Date | string
  /**
   * 是否收款/付款
   *
   * 字典 crm_receivable_received_flag：1 是 / 0 否
   * ★ 回款自身字段（不是合同的），原型列表「是否收款,付款」列 + 新增表单同名下拉。
   */
  receivedFlag?: number
  /** 相关文件（文件 url 逗号串）—— 回款自身字段，收付款单上的自有附件 */
  relatedFiles?: string
  auditStatus: number
  processInstanceId: number
  returnTime: Date
  returnType: number
  price: number
  ownerUserId: number
  ownerUserName?: string
  remark: string
  creator: string // 创建人
  creatorName?: string // 创建人名称
  createTime: Date // 创建时间
  updateTime: Date // 更新时间
}

// 查询回款列表
export const getReceivablePage = async (params) => {
  return await request.get({ url: `/crm/receivable/page`, params })
}

// 查询回款列表
export const getReceivablePageByCustomer = async (params) => {
  return await request.get({ url: `/crm/receivable/page-by-customer`, params })
}

// 查询回款详情
export const getReceivable = async (id: number) => {
  return await request.get({ url: `/crm/receivable/get?id=` + id })
}

// 新增回款
export const createReceivable = async (data: ReceivableVO) => {
  return await request.post({ url: `/crm/receivable/create`, data })
}

// 修改回款
export const updateReceivable = async (data: ReceivableVO) => {
  return await request.put({ url: `/crm/receivable/update`, data })
}

// 删除回款
export const deleteReceivable = async (id: number) => {
  return await request.delete({ url: `/crm/receivable/delete?id=` + id })
}

// 导出回款 Excel
export const exportReceivable = async (params) => {
  return await request.download({ url: `/crm/receivable/export-excel`, params })
}

// 提交审核
export const submitReceivable = async (id: number) => {
  return await request.put({ url: `/crm/receivable/submit?id=${id}` })
}

// 获得待审核回款数量
export const getAuditReceivableCount = async () => {
  return await request.get({ url: '/crm/receivable/audit-count' })
}
